/**
 * Gets 'data-*' property.
 * See https://bugs.webkit.org/show_bug.cgi?id=161454
 */
export const getDatasetProperty = (dataset, propName) => {
  try {
    if (!dataset || !propName) throw Error('!!! ERROR (DOM.fns.getDatasetProperty): Invalid arguments provided.')
    return typeof Reflect !== 'undefined' ? Reflect.get(dataset, propName) : dataset[propName]
  } catch (error) {
    console.log(error)
    MK.captureException(error)
  }
}
